import * as yup from 'yup';

export const validationSchema = yup.object({
  barcode: yup.string().required('This field is required'),
});
